import { Drawer, type DrawerProps } from "@mui/material";
import { type PropsWithChildren } from "react";

const slotProps: DrawerProps["slotProps"] = {
  paper: {
    style: {
      height: "auto",
      borderRadius: 0,
    },
    ref: (node: HTMLDivElement) => {
      const observer = new ResizeObserver(([entry]) => {
        document.body.style.setProperty(
          "--drawer-height",
          `${entry.target.getBoundingClientRect().height}px`,
        );
      });

      observer.observe(node);

      return () => {
        observer.disconnect();
        document.body.style.setProperty("--drawer-height", "0");
      };
    },
  },
};

export const PersistentDrawer = ({
  children,
  ...props
}: PropsWithChildren<DrawerProps>) => {
  return (
    <Drawer
      slotProps={slotProps}
      anchor="bottom"
      variant="persistent"
      open
      {...props}
    >
      <div className="w-full">{children}</div>
    </Drawer>
  );
};
